import { Component, OnInit, Input } from '@angular/core';
import { CommonService } from '../../../shared/services/common.service';
import moment from 'moment-timezone';
import { CreateBookingService } from '../../create-booking/create-booking.service';
@Component({
  selector: 'app-booking-details',
  templateUrl: './booking-details.component.html',
  styleUrls: ['./booking-details.component.scss', '../../../shared/styles/summary.scss']
})
export class BookingDetailsComponent implements OnInit {

  @Input() booking: any;
  @Input() showBookingId: any;
  public config: any[];
  public isDetailVisible = true;
  miscelleneousConfig: any;
  isMultiDayBooking = false;

  constructor(private commonService: CommonService, private createBookingService: CreateBookingService) { }

  ngOnInit() {
    this.commonService.fetchMiscConfig().subscribe((response) => {
      this.commonService.miscConfig = response;
      this.miscelleneousConfig = response;
    });
    this.commonService.fetchConfig().subscribe((response: any) => {
      this.config = this.commonService.getConfigForElementKey(response, 'Trip Details Form').elementConfigList;
    });

    this.createBookingService.multiDayBooking.subscribe(res => {
      this.isMultiDayBooking = res;
    });

  }

  toggleView() {
    this.isDetailVisible = !this.isDetailVisible;
  }

  getTimein24HourFormat(time) {
    return time ? moment(time, 'DD/MM/YYYY HH/mm/ss').format('HH:mm') : '';
  }
  getAddress(address){
    return address instanceof Object ?  address.address : address;
  }

}
